import { render } from "./Duraphat.vue?vue&type=template&id=ae5e9b56&scoped=true"
import script from "./Duraphat.vue?vue&type=script&lang=js"
export * from "./Duraphat.vue?vue&type=script&lang=js"

import "./Duraphat.vue?vue&type=style&index=0&id=ae5e9b56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5e9b56"]])

export default __exports__